<template>
  <v-card
    class="com-pc-card tm-over-list tm-pc-obs-list-card"
    obs-list-type="other"
  >
    <div>
      <v-row class="com-pc-card-header tm-header">
        <span class="com-pc-card-title pb-1">{{ text.title }}</span>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="pb-1"
              icon
              dark
              small
              @click="clickFullLink()"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>fullscreen</v-icon>
            </v-btn>
          </template>
          <span>{{ this.tooltipStr.panelModeOn }}</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="pb-1"
              icon
              dark
              small
              @click="clickOpenNew"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>open_in_new</v-icon>
            </v-btn>
          </template>
          <span>{{ this.tooltipStr.detailView }}</span>
        </v-tooltip>
      </v-row>
    </div>

    <v-col class="tm-box com-pc-card-contents pa-0">
      <div class="tab">
        <!-- 表示切替タブ -->
        <v-btn
          class="com-btn mr-2"
          :class="tmBtnStates(0)"
          @click="clickTab(0)"
          >{{ text.stage }}</v-btn
        >
        <v-btn class="com-btn" :class="tmBtnStates(1)" @click="clickTab(1)">{{
          text.rain
        }}</v-btn>
        <v-btn
          class="com-btn ml-2"
          :class="tmBtnStates(2)"
          style="white-space: pre-wrap"
          @click="clickTab(2)"
          >{{ text.swstg }}</v-btn
        >
      </div>
      <v-col class="tm-box-list">
        <!-- 水位観測の基準値超過一覧を表示 -->
        <div v-show="tabIndex === 0" class="tm-list">
          <!-- 読み込み中 -->
          <div
            v-if="
              this.reqParam.appTime != this.tmOverDatasParam.dispTime ||
                this.reqParam.townsAcqTime != this.tmOverDatasParam.townsAcqTime
            "
            class="tm-progress"
          >
            <v-progress-circular
              v-if="
                this.reqParam.appTime != this.tmOverDatasParam.dispTime ||
                  this.reqParam.townsAcqTime !=
                    this.tmOverDatasParam.townsAcqTime
              "
              indeterminate
              :size="30"
              :width="5"
            ></v-progress-circular>
          </div>
          <!-- 読み込み済み -->
          <div
            v-if="
              this.reqParam.appTime == this.tmOverDatasParam.dispTime &&
                this.reqParam.townsAcqTime == this.tmOverDatasParam.townsAcqTime
            "
          >
            <v-col
              class="tm-no-regist"
              v-if="!tmOverDatas.tmStg || tmOverDatas.tmStg.length == 0"
              >{{
                this.$store.state.app.config.messageConfig.ovNoRegist
              }}</v-col
            >
            <v-list
              class="pa-0"
              light
              v-for="(tmStg, tmStgIdx) in tmOverDatas.tmStg"
              :key="tmStgIdx"
            >
              <v-list-group no-action>
                <template v-slot:activator>
                  <v-list-item>
                    <v-list-item-action class="list-icon">
                      <img
                        v-if="tmStg.stgOvlvl === 30 && tmStg.stgChg < 0"
                        src="/kawabou/img/obs_icons/obs_water_caution_down.svg"
                        class="tm-icon-telemeter"
                      />
                      <img
                        v-if="tmStg.stgOvlvl === 30 && tmStg.stgChg === 0"
                        src="/kawabou/img/obs_icons/obs_water_caution.svg"
                        class="tm-icon-telemeter"
                      />
                      <img
                        v-if="tmStg.stgOvlvl === 30 && tmStg.stgChg > 0"
                        src="/kawabou/img/obs_icons/obs_water_caution_up.svg"
                        class="tm-icon-telemeter"
                      />
                      <img
                        v-if="tmStg.stgOvlvl === 60 && tmStg.stgChg < 0"
                        src="/kawabou/img/obs_icons/obs_water_refuge_down.svg"
                        class="tm-icon-telemeter"
                      />
                      <img
                        v-if="tmStg.stgOvlvl === 60 && tmStg.stgChg === 0"
                        src="/kawabou/img/obs_icons/obs_water_refuge.svg"
                        class="tm-icon-telemeter"
                      />
                      <img
                        v-if="tmStg.stgOvlvl === 60 && tmStg.stgChg > 0"
                        src="/kawabou/img/obs_icons/obs_water_refuge_up.svg"
                        class="tm-icon-telemeter"
                      />
                      <img
                        v-if="tmStg.stgOvlvl === 80 && tmStg.stgChg < 0"
                        src="/kawabou/img/obs_icons/obs_water_danger_down.svg"
                        class="tm-icon-telemeter"
                      />
                      <img
                        v-if="tmStg.stgOvlvl === 80 && tmStg.stgChg === 0"
                        src="/kawabou/img/obs_icons/obs_water_danger.svg"
                        class="tm-icon-telemeter"
                      />
                      <img
                        v-if="tmStg.stgOvlvl === 80 && tmStg.stgChg > 0"
                        src="/kawabou/img/obs_icons/obs_water_danger_up.svg"
                        class="tm-icon-telemeter"
                      />
                      <img
                        v-if="tmStg.stgOvlvl === 90 && tmStg.stgChg < 0"
                        src="/kawabou/img/obs_icons/obs_water_flood_down.svg"
                        class="tm-icon-telemeter"
                      />
                      <img
                        v-if="tmStg.stgOvlvl === 90 && tmStg.stgChg === 0"
                        src="/kawabou/img/obs_icons/obs_water_flood.svg"
                        class="tm-icon-telemeter"
                      />
                      <img
                        v-if="tmStg.stgOvlvl === 90 && tmStg.stgChg > 0"
                        src="/kawabou/img/obs_icons/obs_water_flood_up.svg"
                        class="tm-icon-telemeter"
                      />
                    </v-list-item-action>
                    <v-list-item-content>
                      <!-- 基準観測所有り観測所名 -->
                      <v-list-item-title
                        v-if="
                          tmStg.fldfrFlg === 1 ||
                            tmStg.evstgFlg === 1 ||
                            (isFldCtl && tmStg.fldctlFlg === 1)
                        "
                        >{{ tmStg.obsNm }}{{ referenceObs }}</v-list-item-title
                      >
                      <!-- 基準観測所なし観測所名 -->
                      <v-list-item-title
                        v-if="
                          tmStg.fldfrFlg === 0 &&
                            tmStg.evstgFlg === 0 &&
                            (!isFldCtl || tmStg.fldctlFlg === 0)
                        "
                        >{{ tmStg.obsNm }}</v-list-item-title
                      >
                      <v-list-item-subtitle>
                        {{ tmStg.rvrNm }}({{ tmStg.rsysNm }}水系)
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{ getDispDate(tmStg.obsTime) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <!--河床から -->
                    <v-list-item-title
                      class="tm-value"
                      v-if="
                        stgMode === '0' ||
                          (stgMode === '1' && tmStg.dspFlg === 2)
                      "
                      >{{ stgMsg.normalStg
                      }}{{ formatStg(tmStg.stg) }}m</v-list-item-title
                    >
                    <!--堤防高から -->
                    <v-list-item-title
                      class="tm-value"
                      v-if="stgMode === '1' && tmStg.dspFlg === 1"
                      >{{ stgMsg.topendStg
                      }}{{ formatStg(tmStg.stgHght) }}m</v-list-item-title
                    >
                  </v-list-item-content>
                  <!-- 上昇下降の矢印 -->
                  <v-list-item-action>
                    <v-icon v-if="tmStg.stgChg < 0" class="icon-arrow-down"
                      >arrow_downward</v-icon
                    >
                    <v-icon v-if="tmStg.stgChg === 0" class="icon-arrow-down"
                      >arrow_forward</v-icon
                    >
                    <v-icon v-if="tmStg.stgChg > 0" class="icon-arrow-up"
                      >arrow_upward</v-icon
                    >
                  </v-list-item-action>
                  <!-- 品管フラグ -->
                  <v-list-item-action>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-if="tmStg.stgQmflg && tmStg.stgQmflg != '0'"
                          v-on="on"
                          class="icon-qmflg"
                          >warning</v-icon
                        >
                      </template>
                      <span>{{ text.abnormal }}</span>
                    </v-tooltip>
                  </v-list-item-action>
                  <v-list-item-action>
                    <v-btn
                      outlined
                      small
                      color="success"
                      class="tm-disp-button"
                      @click="
                        clickOverList(tmStg.ofcCd, tmStg.itmkndCd, tmStg.obsCd)
                      "
                    >
                      <v-icon left>link</v-icon>
                      <span>{{ text.show }}</span>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
              <v-divider></v-divider>
            </v-list>
          </div>
        </div>
        <!-- 雨量の基準値超過一覧を表示 -->
        <div v-show="tabIndex === 1" class="tm-list">
          <!-- 読み込み中 -->
          <div
            v-if="
              this.reqParam.appTime != this.tmOverDatasParam.dispTime ||
                this.reqParam.townsAcqTime != this.tmOverDatasParam.townsAcqTime
            "
            class="tm-progress"
          >
            <v-progress-circular
              v-if="
                this.reqParam.appTime != this.tmOverDatasParam.dispTime ||
                  this.reqParam.townsAcqTime !=
                    this.tmOverDatasParam.townsAcqTime
              "
              indeterminate
              :size="30"
              :width="5"
            ></v-progress-circular>
          </div>
          <!-- 読み込み済み -->
          <div
            v-if="
              this.reqParam.appTime == this.tmOverDatasParam.dispTime &&
                this.reqParam.townsAcqTime == this.tmOverDatasParam.townsAcqTime
            "
          >
            <v-col
              class="tm-no-regist"
              v-if="!tmOverDatas.tmRn || tmOverDatas.tmRn.length == 0"
              >{{
                this.$store.state.app.config.messageConfig.ovNoRegist
              }}</v-col
            >
            <v-list
              class="pa-0"
              light
              v-for="(trRn, trRnIdx) in tmOverDatas.tmRn"
              :key="trRnIdx"
            >
              <v-list-group no-action>
                <template v-slot:activator>
                  <v-list-item>
                    <v-list-item-action class="list-icon">
                      <img
                        src="/kawabou/img/obs_icons/obs_rain_normal.svg"
                        class="tm-icon-telemeter"
                      />
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title class="rp-0">
                        {{ trRn.obsNm }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ trRn.rvrNm }}({{ trRn.rsysNm }}水系)
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{ getDispDate(trRn.obsTime) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title class="tm-value"
                      >{{ text.hourRain }} {{ trRn.rn60m }}mm</v-list-item-title
                    >
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-if="trRn.rn60mQmflg && trRn.rn60mQmflg != '0'"
                          v-on="on"
                          class="icon-qmflg"
                          >warning</v-icon
                        >
                      </template>
                      <span>{{ text.abnormal }}</span>
                    </v-tooltip>
                  </v-list-item-action>
                  <v-list-item-action>
                    <v-btn
                      outlined
                      small
                      color="success"
                      class="tm-disp-button"
                      @click="
                        clickOverList(trRn.ofcCd, trRn.itmkndCd, trRn.obsCd)
                      "
                    >
                      <v-icon left>link</v-icon>
                      <span>{{ text.show }}</span>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
              <v-divider></v-divider>
            </v-list>
          </div>
        </div>
        <!-- 水位計の基準値超過一覧を表示 -->
        <div v-show="tabIndex === 2" class="tm-list">
          <!-- 読み込み中 -->
          <div
            v-if="
              this.reqParam.appTime != this.tmOverDatasParam.dispTime ||
                this.reqParam.townsAcqTime != this.tmOverDatasParam.townsAcqTime
            "
            class="tm-progress"
          >
            <v-progress-circular
              v-if="
                this.reqParam.appTime != this.tmOverDatasParam.dispTime ||
                  this.reqParam.townsAcqTime !=
                    this.tmOverDatasParam.townsAcqTime
              "
              indeterminate
              :size="30"
              :width="5"
            ></v-progress-circular>
          </div>
          <!-- 読み込み済み -->
          <div
            v-if="
              this.reqParam.appTime == this.tmOverDatasParam.dispTime &&
                this.reqParam.townsAcqTime == this.tmOverDatasParam.townsAcqTime
            "
          >
            <v-col
              class="tm-no-regist"
              v-if="!tmOverDatas.swStg || tmOverDatas.swStg.length == 0"
              >{{
                this.$store.state.app.config.messageConfig.ovNoRegist
              }}</v-col
            >
            <v-list
              class="pa-0"
              light
              v-for="(swStg, swStgIdx) in tmOverDatas.swStg"
              :key="swStgIdx"
            >
              <v-list-group no-action>
                <template v-slot:activator>
                  <v-list-item>
                    <v-list-item-action class="list-icon">
                      <img
                        v-if="swStg.swstgOvlvl === 30"
                        src="/kawabou/img/obs_icons/obs_swstg_start.svg"
                        class="tm-icon-telemeter"
                      />
                      <img
                        v-if="
                          swStg.swstgOvlvl ===
                            config.overViewConfig.swstg.dispOvlvl
                        "
                        src="/kawabou/img/obs_icons/obs_swstg_danger.svg"
                        class="tm-icon-telemeter"
                      />
                      <img
                        v-if="swStg.swstgOvlvl === 90"
                        src="/kawabou/img/obs_icons/obs_swstg_flood.svg"
                        class="tm-icon-telemeter"
                      />
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ swStg.swobsNm }}</v-list-item-title>
                      <v-list-item-subtitle>
                        {{ swStg.swrvrNm }}({{ swStg.swrsysNm }}水系)
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{ getDispDate(swStg.obsTime) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <!--堤防高から -->
                    <v-list-item-title class="tm-value"
                      >{{ stgMsg.topendStg
                      }}{{ formatStg(swStg.stgHght) }}m</v-list-item-title
                    >
                  </v-list-item-content>
                  <!-- 品管フラグ -->
                  <v-list-item-action>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-if="swStg.stgQmflg && swStg.stgQmflg != '0'"
                          v-on="on"
                          class="icon-qmflg"
                          >warning</v-icon
                        >
                      </template>
                      <span>{{ text.abnormal }}</span>
                    </v-tooltip>
                  </v-list-item-action>
                  <v-list-item-action>
                    <v-btn
                      outlined
                      small
                      color="success"
                      class="tm-disp-button"
                      @click="clickOverList(swStg.swofcCd, 300, swStg.swobsCd)"
                    >
                      <v-icon left>link</v-icon>
                      <span>{{ text.show }}</span>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
              <v-divider></v-divider>
            </v-list>
          </div>
        </div>
      </v-col>
    </v-col>
  </v-card>
</template>
<script>
import mixin from "./../../lib/mixin.js";
import Util from "./../../lib/util.js";
import PageLog from "./../../lib/pageLog.js";
import { setTimeout } from "timers";
export default {
  name: "tm-over-list",
  mixins: [mixin],
  data() {
    return {
      tabIndex: 0,
      /** 文字列リソース */
      text: {
        abnormal: "異常のおそれあり",
        title: "基準値超過観測所一覧",
        stage: "水位観測",
        rain: "雨量",
        swstg: this.$store.state.app.config.replaceNameConfig.swstgLF,
        show: "表示",
        hourRain: "60分雨量",
      },
    };
  },
  /**
   * マウント後イベント
   */
  mounted() {
    this.$log.debug("[TmOverList] mounted()");

    // パラメータによって初期表示するタブを変更
    let knd = this.$route.query["knd"];
    if (knd === "stg") {
      this.tabIndex = 0;
    } else if (knd === "rn") {
      this.tabIndex = 1;
    } else if (knd === "swstg") {
      this.tabIndex = 2;
    }

    this.getTmOverDatas();
  },
  computed: {
    /**
     * 表示範囲のテレメータ超過情報
     */
    tmOverDatas: {
      get() {
        return this.$store.state.Telemeter.tmOverDatas;
      },
    },
    /**
     * 表示範囲のテレメータ超過情報パラメータ
     */
    tmOverDatasParam: {
      get() {
        return this.$store.state.Telemeter.tmOverDatasParam;
      },
    },
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return {
          appTime: this.$store.state.app.appTimeRound,
          towns: this.$store.state.map.towns,
          prefs: this.$store.state.map.prefs,
          townsAcqTime: this.$store.state.map.townsAcqTime,
        };
      },
    },
    pcPanelMode: {
      get() {
        return this.$store.state.app.pcPanelMode;
      },
    },
    /**
     * 水位表示
     */
    stgMode: {
      get() {
        return this.$store.state.app.stgMode;
      },
    },
    /**
     * 水位表示切替メッセージ
     */
    stgMsg: {
      get() {
        return this.$store.state.app.config.messageConfig.stg;
      },
    },
    /**
     * 基準観測所
     */
    referenceObs: {
      get() {
        return this.$store.state.app.config.messageConfig.obsList.referenceObs;
      },
    },
    /**
     * 水防団モード
     */
    isFldCtl: {
      get() {
        return this.$store.getters["app/isFldCtl"];
      },
    },
    /** ツールチップ共通文言 */
    tooltipStr: {
      get() {
        return this.$store.state.app.config.messageConfig.commonTooltip;
      },
    },
    /** 設定情報 */
    config: {
      get() {
        return this.$store.state.app.config;
      },
    },
  },
  methods: {
    /**
     * タブクリック
     */
    clickTab(index) {
      this.$log.debug("[TmOverList] clickTab(" + index + ")");
      this.tabIndex = index;
      let knd = "";
      let pLogNm = "";
      if (index === 0) {
        knd = "stg";
        pLogNm = "over_stg";
      } else if (index === 1) {
        knd = "rn";
        pLogNm = "over_rain";
      } else if (index === 2) {
        knd = "swstg";
        pLogNm = "over_sw";
      }
      // アクセスログ出力
      PageLog.log({
        page_log: pLogNm,
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      let setQuery = Object.assign({}, this.$route.query);
      setQuery.knd = knd;
      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
    },
    /**
     * 表示範囲のテレメータ超過情報を取得
     */
    getTmOverDatas() {
      this.$log.debug("[TmOverList] getTmOverDatas()");
      // アクセスログ出力
      // ログ名称設定
      let pLogNm = "";
      if (this.tabIndex == 0) pLogNm = "over_stg";
      if (this.tabIndex == 1) pLogNm = "over_rain";
      if (this.tabIndex == 2) pLogNm = "over_sw";
      PageLog.log({
        page_log: pLogNm,
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      setTimeout(() => {
        if (this.$store.state.map.prefTownType === "pref") {
          this.$store.dispatch("Telemeter/getTmOvDatasPref", {
            appTime: this.reqParam.appTime,
            prefs: this.reqParam.prefs,
            townsAcqTime: this.reqParam.townsAcqTime,
            isCurrent: this.$store.state.app.isCurrent,
            dispOvlvl: this.config.overViewConfig.swstg.dispOvlvl,
          });
        } else {
          this.$store.dispatch("Telemeter/getTmOvDatas", {
            appTime: this.reqParam.appTime,
            towns: this.reqParam.towns,
            townsAcqTime: this.reqParam.townsAcqTime,
            isCurrent: this.$store.state.app.isCurrent,
            dispOvlvl: this.config.overViewConfig.swstg.dispOvlvl,
          });
        }
      }, 500);
    },
    /**
     * 全体表示ボタンクリック
     */
    clickFullLink() {
      this.$log.debug("[TmOverList] clickFullLink()");
      // アクセスログ出力
      // ログ名称設定
      let pLogNm = "";
      if (this.tabIndex == 0) pLogNm = "over_stg";
      if (this.tabIndex == 1) pLogNm = "over_rain";
      if (this.tabIndex == 2) pLogNm = "over_sw";
      PageLog.log({
        page_log: pLogNm,
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.$store.commit("app/setPcPanelMode", true);
      this.$store.commit("app/setPcPanelModeContent", "TmOverList");
      let setQuery = Object.assign({}, this.$route.query);
      setQuery.ext = "1";
      setQuery.ovmd = "tm";
      this.$router.push({
        path: this.$route.path,
        query: setQuery,
      });
    },
    /**
     * 別ウィンドウボタンクリック
     */
    clickOpenNew() {
      this.$log.debug("[TmOverList] clickOpenNew()");
      let knd = "";
      if (this.tabIndex === 0) {
        knd = "stg";
      } else if (this.tabIndex === 1) {
        knd = "rn";
      } else if (this.tabIndex === 2) {
        knd = "swstg";
      }
      // 座標をパラメータにして概況画面（全体表示）を表示
      let routeData = this.$router.resolve({
        name: "ovlist",
        query: {
          zm: this.$store.state.map.zoom,
          minlat: this.$store.state.map.minCoord[0],
          minlon: this.$store.state.map.minCoord[1],
          maxlat: this.$store.state.map.maxCoord[0],
          maxlon: this.$store.state.map.maxCoord[1],
          knd: knd,
          fld: this.$store.state.app.fldCtlParty,
        },
      });
      window.open(routeData.href, "_blank");
    },
    /**
     * 超過一覧の表示ボタンクリック
     */
    clickOverList(ofcCd, itmkndCd, obsCd) {
      this.$log.debug(
        "[TmOverList] clickOverList(" +
          ofcCd +
          ", " +
          itmkndCd +
          ", " +
          obsCd +
          ")"
      );
      // 水位計の場合
      if (itmkndCd == 300) {
        // 選択中テレメータ情報を設定
        this.$store.commit("Swin/setSelectedSwParam", {
          swofcCd: Number(ofcCd),
          itmkndCd: Number(itmkndCd),
          swobsCd: Number(obsCd),
        });
        // 画面遷移
        this.routerPushTmSw("/pc/tm");
      } else {
        // 選択中テレメータ情報を設定
        this.$store.commit("Telemeter/setSelectedTmParam", {
          ofcCd: Number(ofcCd),
          itmkndCd: Number(itmkndCd),
          obsCd: Number(obsCd),
        });
        // 画面遷移
        this.routerPushTm("/pc/tm");
      }
    },
    /**
     * 日付を表示フォーマットに変換
     */
    getDispDate(annTime) {
      this.$log.debug("[TmOverList] getDispDate(" + annTime + ")");
      return Util.formatDate24(annTime, "MM/DD HH:mm");
    },
    /**
     * 水位を小数第2位に変換
     */
    formatStg(stg) {
      this.$log.debug("[TmOverList] formatStg(" + stg + ")");
      return Util.formatFloat(stg, 2);
    },
    /**
     * 基準値超過一覧種別ボタン点滅
     */
    tmBtnStates(idx) {
      this.$log.debug("[TmOverList] tmBtnStates(" + idx + ")");
      // 選択中の基準値超過一覧
      if (idx === this.tabIndex) {
        return "com-btn-on";
        // 選択していない基準値超過一覧で超過中の場合に点滅
      } else if (
        idx === 0 &&
        this.tmOverDatas.tmStg &&
        this.tmOverDatas.tmStg.length > 0
      ) {
        return "com-btn-flash";
      } else if (
        idx === 1 &&
        this.tmOverDatas.tmRn &&
        this.tmOverDatas.tmRn.length > 0
      ) {
        return "com-btn-flash";
      } else if (
        idx === 2 &&
        this.tmOverDatas.swStg &&
        this.tmOverDatas.swStg.length > 0
      ) {
        return "com-btn-flash";
      }
    },
  },
  watch: {
    /**
     * リクエストパラメータ変更時
     */
    reqParam() {
      this.$log.debug("[TmOverList] reqParam()");
      // 表示時刻、市町村リスト取得時刻が変更された場合にJsonファイルを取得
      if (
        this.reqParam.appTime != this.tmOverDatasParam.dispTime ||
        this.reqParam.townsAcqTime != this.tmOverDatasParam.townsAcqTime
      ) {
        this.$log.debug(
          "[TmOverList] req.appTime !== prm.dispTime:" +
            (this.reqParam.appTime != this.tmOverDatasParam.dispTime)
        );
        this.$log.debug(
          "[TmOverList] req.townsAcqTime !== prm.townsAcqTime:" +
            (this.reqParam.townsAcqTime != this.tmOverDatasParam.townsAcqTime)
        );
        this.getTmOverDatas();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../scss/kwb.scss";
.tm-over-list {
  display: flex;
  flex-direction: column;
  height: 100%;

  .tm-header {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
  }

  .tm-box {
    display: flex;
    flex-direction: column;
    height: 100%;
    .tab {
      display: flex;
      flex-direction: row;
      padding: 8px;
    }

    .tm-box-list {
      height: 100%;
      position: relative;

      .tm-list {
        height: 100%;
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        overflow-y: auto;
        overflow-x: hidden;
        .tm-no-regist {
          font-size: 1rem;
        }

        .tm-icon-telemeter {
          width: 26px;
        }
        .tm-value {
          font-size: 0.9rem;
        }
        .icon-arrow-up {
          font-size: 20px;
          color: $color-arrow-up;
        }
        .icon-arrow-down {
          font-size: 20px;
          color: $color-arrow-down;
        }
        .icon-qmflg {
          font-size: 20px;
          color: $color-qmflg;
        }
        .tm-disp-button {
          width: 80px;
        }
      }
    }
  }
}
.cross-info {
  height: 300px;
  padding: 4px;
  .cross-section {
    border: 1px #131212 solid;
    height: 250px;
  }
}

.tm-progress {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
